module.exports = __webpack_public_path__ + "media/images/speedlo-logo-c15fc31c8d70927cb8a661133903ace5.png";